import z from 'zod';

export type CommodityGroupMergedQuery = z.infer<typeof CommodityGroupMergedQuery>;

export const CommodityGroupMergedQuery = z.object({
    /**
     * If true, includes extended data such as metadataHierarchy, labelsHierarchy, and classificationNetworksHierarchy
     */
    extended: z.boolean().optional(),
});
